import React from 'react';
import PropTypes from 'prop-types';
import DialogWithSuccessLayout from '@Containers/Dialogs/DialogsWithIcon/DialogWithSuccessLayout';
import Button from '@Components/Button';

function ConfirmationSuccessDialog(props) {
  const { selfClose } = props;

  return (
    <DialogWithSuccessLayout
      {...props}
      className="registration-confirmation-success-dialog"
      size="md"
      header="Registration completed successfully"
      headerClassName="no-border"
      footer={
        <div className="els-btn-group-right">
          <Button
            buttonConfig={{
              type: 'primary',
              size: 'sm',
              label: 'Got it',
              e2eName: 'registration-confirmation-success-ok',
            }}
            onClick={selfClose}
          />
        </div>
      }
      footerClassName="no-border"
    />
  );
}

ConfirmationSuccessDialog.propTypes = {
  selfClose: PropTypes.func.isRequired,
};

export default ConfirmationSuccessDialog;
